import { COMMON_ERROR } from "constants/error";
import { AxiosWithCommonResponse, ErrorResponse } from "types/response";
import store from "state/store";
import axios, { AxiosError } from "axios";
import queryString from "query-string";
import { HOST_API } from "../constants/host";

const axiosClient = axios.create({
  baseURL: HOST_API.concat("/api/v1"),
  headers: {
    "content-type": "application/json",
  },
  paramsSerializer: {
    serialize: (params) => {
      return queryString.stringify(params, {
        skipEmptyString: true,
        skipNull: true,
      });
    },
  },
});

axiosClient.interceptors.request.use(async (config) => {
  let token = store.getState()?.userInfo?.token;

  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }
  config.timeout = 15000;
  return config;
});

axiosClient.interceptors.response.use(
  (response: AxiosWithCommonResponse) => {
    if (response?.data?.errorCode === COMMON_ERROR.SUCCESS.errorCode) {
      response.data.success = true;
    }
    return response;
  },
  (error: AxiosError<ErrorResponse>) => {
    throw error;
  },
);
export default axiosClient;
